import cx from "classnames";
import React from "react";
import CircleIcon from "./CircleIcon";

type SkillProps = {
  description: React.ReactNode;
  header: string;
  icon: React.ReactElement;
};

const Skill: React.FC<SkillProps> = ({
  description,
  header,
  icon,
}: SkillProps): React.ReactElement => (
  <div
    className={cx([
      "u-margin-left-1rem",
      "u-margin-right-1rem",
      "u-text-center",
    ])}
  >
    <div className={cx(["u-flex", "u-flex-row", "u-justify-content-center"])}>
      <div
        className={cx([
          "julia-website-skill-icon",
          "u-align-items-center",
          "u-flex",
          "u-flex-row",
          "u-justify-content-center",
        ])}
      >
        <CircleIcon
          className="u-position-absolute"
          fill="#DCE7EB"
          height={75}
        />
        {icon}
      </div>
    </div>
    <p
      className={cx([
        "u-color-secondary",
        "u-fontNormal",
        "u-font-size-s",
        "u-line-height-s",
        "u-margin-bottom-3xs",
        "u-margin-top-s",
        "u-text-center",
      ])}
    >
      <strong className="text">{header}</strong>
    </p>
    <p
      className={cx([
        "u-color-secondary",
        "u-font-size-xs",
        "u-line-height-m",
        "u-margin-top-2xs",
        "u-text-center",
        "u-text-normal",
      ])}
    >
      {description}
    </p>
  </div>
);

export default Skill;
